import { IIndexable } from 'core-ts-types';
import { merge } from 'lodash4';

export class ScheduleLocation implements IIndexable {
  id: string;
  campus: number;
  name: string;
  address: string;
  comments: string;
  latitude: number;
  longitude: number;

  constructor(scheduleLocation: Partial<ScheduleLocation>) {
    merge(this, scheduleLocation);
  }

  static build(scheduleLocation: Partial<ScheduleLocation>): ScheduleLocation {
    return new ScheduleLocation(scheduleLocation);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/builders/location_builder.ts